import {
  laboratorySchema,
  validateLaboratorySchema,
} from './schema/laboratorySchema'
import { bargeTankSchema } from './schema/bargeTankSchema'
import { bunkerSchema } from './schema/bunkerInfoSchema'

export { bargeTankSchema, bunkerSchema, laboratorySchema }

export const validateRobBunkerTab = (values, ctx) => {
  validateLaboratorySchema(values, ctx)
}
